import {useCallback,useSyncExternalStore} from 'react';
import {useAuth} from '@/context/AuthContext';
import {pget} from '@/lib/pressure';
import {createMaintenanceStore} from './maintenance-store.mjs';

export const maintenanceSnapshots=createMaintenanceStore(async(path,context)=>{
 const base=path.slice(0,-'/cycle-maintenance'.length);
 if(!context.checkedAt||Date.now()-context.checkedAt>=60000){
  context.settings=await pget(base+'/cycle-settings');
  context.config=context.settings.enabled?await pget(base+'/cycle-maintenance-settings'):null;
  context.checkedAt=Date.now();
 }
 if(!context.settings.enabled||!context.config?.revision||!context.config?.start_at){const error=new Error('Cycle counter or maintenance start not configured');error.response={status:409};throw error;}
 try{return await pget(path);}catch(error){if([401,403,404,409].includes(error.response?.status))context.checkedAt=0;throw error;}
});
export function useMaintenanceSnapshot(deviceId,channel,{enabled=true,interval=30000}={}){
 const auth=useAuth();const user=auth?.user;
 const account=JSON.stringify([user?.id,user?.organization_id,user?.role,user?.all_devices_visible===true]);
 const key=account+'|'+deviceId+'|'+channel,path=`/devices/${deviceId}/channels/${channel}/cycle-maintenance`;
 const active=enabled&&(!auth||Boolean(user));
 const subscribe=useCallback(notify=>active?maintenanceSnapshots.subscribe(key,path,notify,interval):()=>{},[active,key,path,interval]);
 const snapshot=useSyncExternalStore(subscribe,()=>maintenanceSnapshots.get(key));
 const refresh=useCallback(()=>maintenanceSnapshots.refresh(key),[key]);
 return {...snapshot,refresh};
}
